// import * as CompassApi from "../api/compass";
// import Const from "./const";

// export function initConstChannelInfo() {
// 	return CompassApi.GetChannelList()
// 		.then(channelInfo => {
// 			Const.ChannelInfo = channelInfo;
// 		})
// 		.catch(error => {
// 			console.log(error);
// 		});
// }

export function initDemo() {
	return console.log
}